import { getBrowserWidthBucket } from 'owa-layout';
import { CalendarLayoutBrowserConstants } from '../constants';
import { getNumSurfaceViews } from './getNumSurfaceViews';
import { default as isManyDayView } from './isManyDayView';

export function shouldShowDynamicWeekColumns() {
    return getBrowserWidthBucket() < CalendarLayoutBrowserConstants.shouldShowDynamicWeekColumns
        ? false
        : isManyDayView() && getNumSurfaceViews() === 1;
}
